var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.99952C8.53064 3.99952 8.96004 4.42986 8.96004 4.95956C8.96004 5.4902 8.53064 5.9196 8 5.9196C7.46936 5.9196 7.03996 5.4902 7.03996 4.95956C7.03996 4.42986 7.46936 3.99952 8 3.99952ZM8.00001 12.0005C7.55834 12.0005 7.20029 11.6424 7.20029 11.2008V7.19934C7.20029 6.75767 7.55834 6.39962 8.00001 6.39962C8.44169 6.39962 8.79974 6.75767 8.79974 7.19934V11.2008C8.79974 11.6424 8.44169 12.0005 8.00001 12.0005ZM8 14.4006C11.5289 14.4006 14.4006 11.5289 14.4006 8C14.4006 4.47114 11.5289 1.59942 8 1.59942C4.47114 1.59942 1.59942 4.47114 1.59942 8C1.59942 11.5289 4.47114 14.4006 8 14.4006ZM8 0C12.4176 0 16 3.58142 16 8C16 12.4186 12.4176 16 8 16C3.58238 16 0 12.4186 0 8C0 3.58142 3.58238 0 8 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltip-icon.9ad94faffbf13679d484163e6c3f1c6c.svg";
export { ForwardRef as ReactComponent };